module.exports = __webpack_public_path__ + "img/eye-solid.af7e00c7.svg";